export default function LoadingSpinner({
  message,
  height = "h-64",
}: {
  message?: string;
  height?: string; // Tailwind height class to fit context (e.g., h-[300px])
}) {
  return (
    <div className={`flex items-center justify-center ${height}`}>
      <div className="flex flex-col items-center gap-3">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4618B0]"></div>
        {message ? (
          <div className="text-sm text-gray-600">{message}</div>
        ) : null}
      </div>
    </div>
  );
}
